import React, { useState } from 'react'
import { useIntl } from 'react-intl'
import { clamp } from 'utilities/math'
import { StatusLayout } from '../s'
import ProgressIndicator from 'components/progress-indicator'
import Message from 'components/message'
import { InlineButton } from 'components/button'
import Modal from 'modals/dialog'
import Failed from './failed'

const Status = ({ progress, failed }) => {
    const { formatMessage } = useIntl()

    const [showFailed, setShowFailed] = useState(false)

    const ready = !progress.busy && !progress.settled
    if(ready) {
        return null
    }

    const current = progress.processed / progress.total * 100
    const done = !progress.busy && !!progress.settled

    const allSkipped = progress.skipped === progress.total
    const someSkipped = !!progress.skipped && !allSkipped

    const allFailed = progress.failed === progress.total
    const someFailed = !!failed?.length && !allFailed

    return (
        <>
            <StatusLayout>
                <ProgressIndicator
                    values={[clamp(current, 3, 100)]}
                    salt="documents:bulk:category" />
                {(done && someSkipped) && (
                    <Message
                        type="info"
                        className="compact"
                        message={formatMessage({
                            id: 'documents_bulk_status_skipped_some',
                            defaultMessage: '{skipped, plural, =0 {} =1 {Processing of the document was skipped due to no changes.} other {Processing of {skipped} of {total} documents was skipped due to no changes.}}'
                        }, progress)} />
                )}
                {(done && allSkipped) && (
                    <Message
                        type="info"
                        className="compact"
                        message={formatMessage({
                            id: 'documents_bulk_status_skipped_all',
                            defaultMessage: '{skipped, plural, =0 {} =1 {Processing of the document was skipped due to no changes.} other {Processing of all {total} documents was skipped due to no changes.}}'
                        }, progress)} />
                )}
                {(done && someFailed) && (
                    <Message
                        type="warning"
                        className="compact"
                        message={formatMessage({
                            id: 'documents_bulk_status_failed_some',
                            defaultMessage: '{failed, plural, =0 {} =1 {Processing of the document failed. <button>View details<\/button>} other {Processing of {failed} of {total} documents failed. <button>View details<\/button>}}'
                        }, {
                            ...progress,
                            button: chunks => (
                                <InlineButton
                                    onClick={() => setShowFailed(true)}
                                    className="neutral">
                                    {chunks}
                                </InlineButton>
                            )
                        })} />
                )}
                {(done && allFailed) && (
                    <Message
                        type="error"
                        className="compact"
                        message={formatMessage({
                            id: 'documents_bulk_status_failed_all',
                            defaultMessage: '{failed, plural, =0 {} =1 {Processing of the document failed. <button>View details<\/button>} other {Processing of all {total} documents failed. <button>View details<\/button>}}'
                        }, {
                            ...progress,
                            button: chunks => (
                                <InlineButton
                                    onClick={() => setShowFailed(true)}
                                    className="neutral">
                                    {chunks}
                                </InlineButton>
                            )
                        })} />
                )}
            </StatusLayout>
            <Modal
                show={showFailed}
                dismiss={() => setShowFailed(false)}
                className="scrollable"
                salt="documents:bulk:status:view-failed">
                <Failed failed={failed} />
            </Modal>
        </>
    )
}

export default Status